import React from "react";
import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import MasterStaffEditProfileComponent from "../components/auth/profile/MasterStaffEditProfileComponent";

const MasterStaffUpdateProfilePage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Update Profile"
        routes={[{ title: "Home", path: "/" }]}
      />
      <MasterStaffEditProfileComponent />
    </>
  );
};
export default MasterStaffUpdateProfilePage;
